const dictionary = {
    _linkOpenAccess: {
        en: 'https://en.wikipedia.org/wiki/Open_access',
        de: 'https://de.wikipedia.org/wiki/Open_Access',
        pl: 'https://pl.wikipedia.org/wiki/Otwarty_dostęp',
    },
    _linkCreativeCommons: {
        en: 'https://creativecommons.org/licenses/by-sa/4.0/deed.en',
        de: 'https://creativecommons.org/licenses/by-sa/4.0/deed.de',
        pl: 'https://creativecommons.org/licenses/by-sa/4.0/deed.pl',
    },
    _linkFB: {
        en: '',
        de: '',
        pl: '',
    },
    _linkInsta: {
        en: '',
        de: '',
        pl: '',
    },
    abstracts: {
        en: 'Abstracts',
        de: 'Abstracts',
        pl: 'Abstrakty',
    },
    archive: {
        en: 'All volumes',
        de: 'Alle Bände',
        pl: 'Wszystkie tomy',
    },
    audioFile: {
        en: 'Audio file',
        de: 'Tonbeispiel',
        pl: 'Plik dźwiękowy',
    },
    authorsIndex: {
        en: 'Authors',
        de: 'Autoren',
        pl: 'Autorzy',
    },
    bounceRate: {
        en: 'Rejection Rate',
        de: 'Absprungrate',
        pl: 'Współczynnik odrzuceń',
    },
    contents: {
        en: 'Contents',
        de: 'Inhalt',
        pl: 'Spis treści',
    },
    creativeCommonsInfo: {
        en: 'Texts published in the ‘Beiträge zur allgemeinen und vergleichenden Sprachwissenschaft / Contributions to General and Comparative Linguistics’ are available in the Open Access on the basis of the CC BY-SA license.',
        de: 'Texte, die in der Zeitschrift „Beiträge zur allgemeinen und vergleichenden Sprachwissenschaft / Contributions to General and Comparative Linguistics“ veröffentlicht werden, stehen allen Nutzern im Open Access auf Grund der Lizenz CC BY-SA zur Verfügung.',
        pl: 'Teksty publikowane w czasopiśmie „Beiträge zur allgemeinen und vergleichenden Sprachwissenschaft / Contributions to General and Comparative Linguistics” są udostępniane w wolnym dostępie (Open Access) na podstawie licencji CC BY-SA.',
    },
    issue: {
        en: 'Issue',
        de: 'Heft',
        pl: 'Numer',
    },
    keywords: {
        en: 'Keywords',
        de: 'Schlüsselwörter',
        pl: 'Słowa kluczowe',
    },
    keywordsIndex: {
        en: 'Keyword database',
        de: 'Index der Schlüsselwörter',
        pl: 'Baza słów kluczowych',
    },
    newsletter: {
        en: 'Newsletter',
        de: 'Newsletter',
        pl: 'Newsletter',
    },
    pp: {
        en: 'pp.',
        de: 'S.',
        pl: 's.',
    },
    publishedOnline: {
        en: 'published online',
        de: 'online zugänglich',
        pl: 'data publikacji online',
    },
    noResults: {
        en: 'No results',
        de: 'Keine Ergebnisse',
        pl: 'Brak wyników',
    },
    reviewers: {
        en: 'Reviewers',
        de: 'Gutachter',
        pl: 'Recenzenci',
    },
    searchResultsFor: {
        en: 'Search results for “*”',
        de: 'Suchergebnisse für „*“',
        pl: 'Wyniki wyszukiwania dla „*”',
    },
    searchByAuthorResultsFor: {
        en: 'Search results for “*” (author)',
        de: 'Suchergebnisse für „*“ (Author)',
        pl: 'Wyniki wyszukiwania dla „*” (autor)',
    },
    searchByKeywordResultsFor: {
        en: 'Search results for “*” (keyword)',
        de: 'Suchergebnisse für „*“ (Schlüsselwort)',
        pl: 'Wyniki wyszukiwania dla „*” (słowo kluczowe)',
    },
};

export default dictionary;
